import { userService } from '../../services/user.service'

// initial state
const state = () => ({
  users: [],
  user: null
})

// actions
const actions = {
  getUsers({ commit }, userId) {
    userService.getUsers(userId).then(
      (users) => {
        commit('getUsersSuccess', users)
      },
      (error) => {
        commit('getUsersFailure', error)
      }
    )
  },
  getUsersByCompany({ commit }, companyId) {
    userService.getUsersByCompany(companyId).then(
      (users) => {
        commit('getUsersSuccess', users)
      },
      (error) => {
        commit('getUsersFailure', error)
      }
    )
  },
  getUser({ commit }, userId) {
    userService.getUser(userId).then(
      (user) => {
        commit('getUserSuccess', user)
      },
      (error) => {
        commit('getUserFailure', error)
      }
    )
  },
  createUser({ commit }, userData) {
    return userService.createUser(userData).then(
      (user) => {
        commit('getUserSuccess', user)
        return user
      },
      (error) => {
        commit('getUserFailure', error)
        return error
      }
    )
  },
  updateUser({ commit }, { userId, userData }) {
    userService.updateUser(userId, userData).then(
      (user) => {
        commit('getUserSuccess', user)
      },
      (error) => {
        commit('getUserFailure', error)
      }
    )
  },
  deleteUser({ commit }, userId) {
    userService.deleteUser(userId).then(
      (user) => {
        commit('getUserSuccess', user)
      },
      (error) => {
        commit('getUserFailure', error)
      }
    )
  }
}

// mutations
const mutations = {
  getUsersSuccess(state, users) {
    state.users = users
  },
  getUserSuccess(state, user) {
    state.user = user
  },
  getUsersFailure(state, error) {
    console.log(state, error)
  },
  getUserFailure(state, error) {
    console.log(state, error)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
